export default {
    activeDropdown: null
} 